import type { NnnRegistrationRowKenmerk } from '@/api';
import type { NnnKenmerkSectie } from '../types/careplan-nnn.types';
import { kenmerkKey } from './kenmerk-key';

export function selectRowKenmerken(
  secties: NnnKenmerkSectie[],
  checkedKeys: ReadonlySet<string>
): NnnRegistrationRowKenmerk[] {
  const selected: NnnRegistrationRowKenmerk[] = [];
  for (const sectie of secties) {
    for (const groep of sectie.groepen) {
      for (const kenmerk of groep.kenmerken) {
        if (kenmerk.code === null) {
          continue;
        }
        const ref = String(kenmerk.code);
        if (checkedKeys.has(kenmerkKey(sectie.type, ref))) {
          selected.push({ id: null, type: sectie.type, nnnKenmerkDbRef: ref });
        }
      }
    }
  }
  return selected;
}
